import { Component } from "react";
import PropTypes from "prop-types";

export default class TablePagination extends Component {
  render() {
    let { tables, tableKey, itemsCount, changePageSize } = this.props;
    let pagination = tables[tableKey].pagination;
    let pageSize = pagination.take;

    let pagesCount = Math.ceil(itemsCount / pagination.take);

    let pagesRows = [];
    const PAGES_TO_DISPALY_FROM_SELECTED = 7;

    let startPage = pagination.page - PAGES_TO_DISPALY_FROM_SELECTED;
    startPage = startPage <= 0 ? 1 : startPage;

    let endPage = pagination.page + PAGES_TO_DISPALY_FROM_SELECTED;
    endPage = endPage > pagesCount ? pagesCount : endPage;

    if (startPage != 1) {
      pagesRows.push(
        <div
          style={{ padding: "4px 7px", display: "inline-block" }}
          key={"dots-1"}
        >
          &hellip;
        </div>,
      );
    }

    for (var i = startPage; i <= endPage; i++) {
      if (i == pagination.page) {
        pagesRows.push(
          <div key={i} className="react-table-page active">
            {i}
          </div>,
        );
      } else {
        pagesRows.push(
          <div
            key={i}
            onClick={this.props.changePage.bind(this, i, tableKey)}
            className="react-table-page"
          >
            {i}
          </div>,
        );
      }
    }

    if (endPage != pagesCount) {
      pagesRows.push(
        <div
          style={{ padding: "4px 7px", display: "inline-block" }}
          key={"dots-2"}
        >
          &hellip;
        </div>,
      );
    }

    return (
      <div>
        <div className="react-table-pages-container">
          <div className="react-table-pagination-container">
            <div
              className={
                "react-table-page react-table-firstPage " +
                (pageSize == 10 ? "active" : "")
              }
              onClick={changePageSize.bind(this, 10, tableKey)}
            >
              10
            </div>
            <div
              className={"react-table-page " + (pageSize == 20 ? "active" : "")}
              onClick={changePageSize.bind(this, 20, tableKey)}
            >
              20
            </div>
            <div
              className={"react-table-page " + (pageSize == 50 ? "active" : "")}
              onClick={changePageSize.bind(this, 50, tableKey)}
            >
              50
            </div>
            <div
              className={
                "react-table-page react-table-lastPage " +
                (pageSize == 100 ? "active" : "")
              }
              onClick={changePageSize.bind(this, 100, tableKey)}
            >
              100
            </div>
          </div>
          <div>Page sizes </div>
        </div>
        <div className="react-table-pages-container">
          <div className="react-table-pagination-container">
            <div
              className="react-table-page react-table-firstPage"
              onClick={this.props.changePage.bind(this, 1, tableKey)}
            >
              First
            </div>
            {pagesRows}
            <div
              className="react-table-page react-table-lastPage"
              onClick={this.props.changePage.bind(this, pagesCount, tableKey)}
            >
              Last
            </div>
          </div>
          <div>No. of pages: {pagesCount}</div>
        </div>
      </div>
    );
  }

  static propTypes = {
    tables: PropTypes.object,
    tableKey: PropTypes.string.isRequired,
    itemsCount: PropTypes.number.isRequired,
    changePage: PropTypes.func.isRequired,
  };
}
